<template>
  <el-form
    label-position="left"
    :model="otherForm"
    status-icon
    ref="otherForm"
    @submit.native.prevent="next('otherForm', otherForm)"
  >
    <el-row :gutter="15" justify="center" type="flex" v-loading="saving">
      <el-col :span="24">
        <el-row :gutter="15">
          <el-col :span="4">
            <el-form-item label="Código anterior">
              <el-input
                size="small"
                :autofocus="true"
                v-model="otherForm.priorCode"
                autocomplete="off"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="Cargo">
              <el-select
                v-model="otherForm.department"
                placeholder="Seleccionar"
                size="small"
                class="w-full"
                filterable
                default-first-option
              >
                <el-option
                  v-for="d in departments"
                  :key="d.id"
                  :label="d.name"
                  :value="d.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="Puesto de trabajo">
              <el-select
                v-model="otherForm.jobPosition"
                placeholder="Seleccionar"
                size="small"
                class="w-full"
                filterable
                default-first-option
              >
                <el-option
                  v-for="jp in jobPositions"
                  :key="jp.id"
                  :label="`${jp.code} - ${jp.name}`"
                  :value="jp.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label=" Ingreso de la sucursal o CD">
              <el-select
                v-model="otherForm.branchOffice"
                placeholder="Seleccionar"
                size="small"
                class="w-full"
                filterable
                default-first-option
              >
                <el-option
                  v-for="jp in branchOffices"
                  :key="jp.id"
                  :label="`${jp.name}`"
                  :value="jp.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="8">
            <el-form-item label="Centro de costos">
              <el-select
                v-model="otherForm.oldCostCenter"
                placeholder="Seleccionar"
                size="small"
                class="w-full"
                filterable
                default-first-option
              >
                <el-option
                  v-for="jp in oldCostCenters"
                  :key="jp.id"
                  :label="jp.name"
                  :value="jp.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="Departamento">
              <el-select
                v-model="otherForm.oldDepartment"
                placeholder="Seleccionar"
                size="small"
                class="w-full"
                filterable
                default-first-option
              >
                <el-option
                  v-for="jp in oldDepartments"
                  :key="jp.id"
                  :label="jp.name"
                  :value="jp.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="Area de trabajo">
              <el-select
                v-model="otherForm.workingArea"
                placeholder="Seleccionar"
                size="small"
                class="w-full"
                filterable
                default-first-option
              >
                <el-option
                  v-for="jp in workingAreas"
                  :key="jp.id"
                  :label="jp.name"
                  :value="jp.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="24">
            <el-form-item label="Enfermedades que padece">
              <el-input
                size="small"
                v-model="otherForm.diseasesList"
                autocomplete="off"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="7">
            <el-form-item label="Usuario acciones (H.E. & A.P.)">
              <el-select
                v-model="otherForm.userActions"
                placeholder="Seleccionar"
                size="small"
                class="w-full"
                filterable
                default-first-option
              >
                <el-option
                  v-for="d in userActions"
                  :key="d.id"
                  :label="`${d.names} ${d.lastnames}`"
                  :value="d.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="% Procu. Aguinaldo">
              <el-input-number
                size="small"
                class="w-full"
                v-model="otherForm.procuAguinaldo"
                autocomplete="off"
              />
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="Inclusión en planillas">
              <el-radio-group
                v-model="otherForm.includeInPaysheet"
                class="w-full"
              >
                <el-row :gutter="15">
                  <el-col :span="8">
                    <el-radio border size="small" :label="true" class="w-full"
                      >Incluir</el-radio
                    >
                  </el-col>
                  <el-col :span="8">
                    <el-radio border size="small" :label="false" class="w-full"
                      >Excluir</el-radio
                    >
                  </el-col>
                </el-row>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="24" class="flex justify-end">
            <el-button size="small" @click="$emit('cancel')"
              >Cancelar</el-button
            >
            <el-button size="small" type="primary" native-type="submit"
              >Guardar</el-button
            >
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
import axios from "axios";
import * as R from "ramda";
import dfn from "date-fns";

export default {
  name: "DialogOther",
  props: ["values", "cargos"],
  beforeCreate() {
    axios
      .post("/", {
        query: `{
          departments(where: { active: true }) { id name }
          jobPositions { id code name }
          oldDepartments { id name }
          oldCostCenters { id name }
          workingAreas { id name }
          branchOffices{ id name }
          users { id names lastnames }
        }`,
      })
      .then((res) => {
        const { data, errors } = res.data;
        if (R.isNil(errors)) {
          this.departments = data.departments;
          this.userActions = data.users;
          this.jobPositions = data.jobPositions;
          this.oldCostCenters = data.oldCostCenters;
          this.branchOffices = data.branchOffices;
          this.oldDepartments = data.oldDepartments;
          this.workingAreas = data.workingAreas;
        }
      });
  },
  data() {
    return {
      departments: [],
      users: [],
      otherForm: {
        priorCode: "",
        diseasesList: "",
        department: "",
        userActions: "",
        jobPosition: "",
        oldDepartment: "",
        oldCostCenter: "",
        branchOffice: "",
        procuAguinaldo: 0,
      },
      userActions: [],
      saving: false,
      jobPositions: [],
      oldCostCenters: [],
      branchOffices: [],
      oldDepartments: [],
      workingAreas: [],
    };
  },
  methods: {
    next(formName, datos) {
      this.$refs[formName].validate((valid) => {
        if (!valid) {
          return false;
        }
        this.saving = true;

        this.$confirm(
          "¿Estás seguro que deseas actualizar estos datos?",
          "Confirmación",
          {
            confirmButtonText: "Si, actualizar",
            cancelButtonText: "Cancelar",
            type: "warning",
          }
        )
          .then(() => {
            axios
              .post("/", {
                query: `mutation {
                  employeeUpdate(
                    where: { id: "${datos.id}" },
                    data: {
                      diseasesList: ${
                        datos.diseasesList ? `"${datos.diseasesList}"` : null
                      },
                      priorCode: ${
                        datos.priorCode ? `"${datos.priorCode}"` : null
                      },
                      department: ${datos.department ? datos.department : null},
                      jobPosition: ${
                        datos.jobPosition ? datos.jobPosition : null
                      },
                      oldCostCenter: ${
                        datos.oldCostCenter ? datos.oldCostCenter : null
                      },
                      branchOffice: ${
                        datos.branchOffice ? datos.branchOffice : null
                      },
                      oldDepartment: ${
                        datos.oldDepartment ? datos.oldDepartment : null
                      },
                      workingArea: ${
                        datos.workingArea ? datos.workingArea : null
                      },
                      userActions: ${
                        datos.userActions ? datos.userActions : null
                      },
                      procuAguinaldo: ${
                        datos.procuAguinaldo ? datos.procuAguinaldo : null
                      },
                      includeInPaysheet: ${datos.includeInPaysheet},
                    }
                  ) { id }
                }`,
              })
              .then((res) => {
                const { data, error } = res.data;
                this.$notify({
                  title: "Éxito",
                  message: "Se ha actualizado la información correctamente.",
                  type: "success",
                });
                this.$emit("save", true);
              })
              .catch((err) =>
                this.$notify({
                  title: "Error",
                  message:
                    "Error al actualizar la informacion contacta con tu administrador.",
                  type: "error",
                })
              )
              .then((alw) => {
                this.saving = false;
              });
          })
          .catch((this.saving = false));
      });
    },
  },
  mounted() {
    this.otherForm = this.values;
  },
  updated() {
    this.otherForm = this.values;
  },
};
</script>
